var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/danger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M94.2928 68.9868L66.5594 19.0667C62.8327 12.3501 57.6761 8.66675 51.9994 8.66675C46.3227 8.66675 41.1661 12.3501 37.4394 19.0667L9.70608 68.9868C6.19608 75.3568 5.80608 81.4667 8.62275 86.2768C11.4394 91.0868 16.9861 93.7301 24.2661 93.7301H79.7327C87.0127 93.7301 92.5594 91.0868 95.3761 86.2768C98.1928 81.4667 97.8028 75.3134 94.2928 68.9868Z",
    fill: "#F5315D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52 63.9167C50.2233 63.9167 48.75 62.4433 48.75 60.6667V39C48.75 37.2233 50.2233 35.75 52 35.75C53.7767 35.75 55.25 37.2233 55.25 39V60.6667C55.25 62.4433 53.7767 63.9167 52 63.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51.9993 78C51.7393 78 51.436 77.9567 51.1327 77.9133C50.8727 77.87 50.6127 77.7833 50.3527 77.6533C50.0927 77.5667 49.8327 77.4367 49.5727 77.2633C49.356 77.09 49.1393 76.9167 48.9227 76.7433C48.1427 75.92 47.666 74.7933 47.666 73.6667C47.666 72.54 48.1427 71.4133 48.9227 70.59C49.1393 70.4167 49.356 70.2433 49.5727 70.07C49.8327 69.8967 50.0927 69.7667 50.3527 69.68C50.6127 69.55 50.8727 69.4633 51.1327 69.42C51.696 69.29 52.3027 69.29 52.8227 69.42C53.126 69.4633 53.386 69.55 53.646 69.68C53.906 69.7667 54.166 69.8967 54.426 70.07C54.6427 70.2433 54.8593 70.4167 55.076 70.59C55.856 71.4133 56.3327 72.54 56.3327 73.6667C56.3327 74.7933 55.856 75.92 55.076 76.7433C54.8593 76.9167 54.6427 77.09 54.426 77.2633C54.166 77.4367 53.906 77.5667 53.646 77.6533C53.386 77.7833 53.126 77.87 52.8227 77.9133C52.5627 77.9567 52.2593 78 51.9993 78Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.74f063ba04ce03b8f47d137262a4ffc7.svg";
export { ForwardRef as ReactComponent };